import React, { useState } from "react"
import classnames from "@utils/classnames"
import Section from "@components/section"
import Button from "@components/button"
import PartTitle from "@components/partTitle"
import Title from "@components/title"
import Modal from "@components/modal"
import Slider from "@components/slider"
import RolesSelector from "@components/rolesSelector"
import WechatGameQr from "@components/wechatGameQr"
import ReactSlick from "react-slick"
import styles from "./roles.module.scss"

import striderDotIconImage from "@images/logo-dots/strider.png"
import striderDotIconGlowImage from "@images/logo-dots/strider-glow.png"
import ninjaDotIconImage from "@images/logo-dots/ninja.png"
import ninjaDotIconGlowImage from "@images/logo-dots/ninja-glow.png"
import engineerDotIconImage from "@images/logo-dots/engineer.png"
import engineerDotIconGlowImage from "@images/logo-dots/engineer-glow.png"
import automataDotIconImage from "@images/logo-dots/automata.png"
import automataDotIconGlowImage from "@images/logo-dots/automata-glow.png"

import city1Image from "@images/worlds/city1.jpg"
import city2Image from "@images/worlds/city2.jpg"
import city3Image from "@images/worlds/city3.jpg"
import hunt1Image from "@images/worlds/hunt1.jpg"
import hunt2Image from "@images/worlds/hunt2.jpg"
import hunt3Image from "@images/worlds/hunt3.jpg"
import jianyu1Image from "@images/worlds/jianyu1.jpg"
import jianyu2Image from "@images/worlds/jianyu2.jpg"
import jianyu3Image from "@images/worlds/jianyu3.jpg"
import matrix1Image from "@images/worlds/matrix1.jpg"
import matrix2Image from "@images/worlds/matrix2.jpg"
import matrix3Image from "@images/worlds/matrix3.jpg"

import rtImg from "@images/frame-corner/rt.png"
import rbImg from "@images/frame-corner/rb.png"
import ltImg from "@images/frame-corner/lt.png"
import lbImg from "@images/frame-corner/lb.png"

import wechatGameImg from "@images/wechat-game-qr.png"

const ROLES = [
  {
    key: "engineer",
    dotIcon: [automataDotIconImage, automataDotIconGlowImage],
    world: {
      images: [city1Image, city2Image, city3Image],
      title: "吉考斯城邦",
      en: "GCORES POLIS",
      desc: (
        <>
          当人们还在以羊毛美酒进行对外贸易的时候，吉考斯城邦就已经开始推销和贩卖桌面游戏了。
          <br />
          经过了战火和纷争的考验数个世代后，中立城邦吉考斯仍傲然屹立。而吉考斯城邦最大的阻碍——帝国，
          <br />
          则已经步入黄昏，即将没落。人类的黄金时代宣告来临。
          <br />
          吉考斯城邦不准备止步于此——新的深空计划公布，游戏和文化的传播将继续向着宇宙进发！
        </>
      ),
    },
  },
  {
    key: "ninja",
    dotIcon: [ninjaDotIconImage, ninjaDotIconGlowImage],
    world: {
      images: [jianyu1Image, jianyu2Image, jianyu3Image],
      title: "剑玉忍国",
      en: "NEO Ken-SHINOBI",
      desc: (
        <>
          德川幕府统治这个世界已久。虽然表面光鲜亮丽，但台面下却暗流涌动。
          <br />
          德川幕府倚靠自己麾下的忍者势力暗中做出许多不义之事，也犯下了不少滔天罪行。
          <br />
          一位忍者少年曾经揭竿反抗，虽然一度重创了德川，但在派出的源源不断的追杀过程中还是最终落败，生死未卜。
          <br />
          此事后，德川幕府变本加厉，而曾经前去追杀少年的忍者据说陷入了可怕的疯狂。
        </>
      ),
    },
  },
  {
    key: "automata",
    dotIcon: [engineerDotIconImage, engineerDotIconGlowImage],
    world: {
      images: [matrix1Image, matrix2Image, matrix3Image],
      title: "矩阵空间",
      en: "MATRIX SPACE",
      desc: (
        <>
          在这里，您将见到人类文明的巅峰！您只需要简单的设备就可以深入到璀璨的虚拟空间中。
          <br />
          无垠的世界超越了宇宙星辰所能包容的范围！而您的身体则由互联万物的顶级人工智能照顾。
          <br />
          虽然说您可以随时以强健的体魄回到所谓的现实世界，但谁又会错失可以实现一切愿望真正的“真实世界”呢？
        </>
      ),
    },
  },
  {
    key: "strider",
    dotIcon: [striderDotIconImage, striderDotIconGlowImage],
    world: {
      images: [hunt1Image, hunt2Image, hunt3Image],
      title: "信徒猎区",
      en: "THE HUNT ZONE",
      desc: (
        <>
          信徒猎区是极度危险的战乱世界。
          <br />
          在这里，你要注意章鱼型的蜂巢意志机器人—它们想要将一切活物纳入到自己的教团之中。
          <br />
          另一方，一心只想要狩猎它们的G-hunter—尽管他们是人类，也很难说他们的心智就是正常的。
          <br />
          而就算你没有碰到交战双方，信徒猎区贫瘠的废土环境也无法为你提供多少生存资源。
        </>
      ),
    },
  },
]

const renderModalItem = ({ world: { images, title, en, desc } }) => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    touchMove: false,
    swipeToSlide: false,
    fade: true,
  }
  return (
    <div className={styles.modalItem}>
      <Slider.WholeWidthContainerInMobile className={styles.modalItemSlider}>
        <ReactSlick {...settings}>
          {images.map(image => {
            return (
              <div>
                <img className={styles.modelItemSliderImage} src={image} />
              </div>
            )
          })}
        </ReactSlick>
        <img src={rtImg} className={styles.rt} />
        <img src={rbImg} className={styles.rb} />
        <img src={ltImg} className={styles.lt} />
        <img src={lbImg} className={styles.lb} />
      </Slider.WholeWidthContainerInMobile>
      <h3>
        <span>{title}</span>
        <small>{en}</small>
      </h3>
      <p>{desc}</p>
    </div>
  )
}

const ModalBody = ({ closeModal, role }) => {
  return (
    <Slider
      data={ROLES}
      customDots={ROLES.map(role => role.dotIcon)}
      renderItem={item => renderModalItem(item)}
      initialSlide={ROLES.map(r => r.key).indexOf(role)}
      onClose={closeModal}
    />
  )
}

const Roles = React.memo(props => {
  const [currentSelectedRole, setCurrentSelectedRole] = useState(null)
  const closeModal = () => {
    setCurrentSelectedRole(null)
  }
  return (
    <Section>
      <Modal isOpen={currentSelectedRole !== null} onRequestClose={closeModal}>
        <ModalBody closeModal={closeModal} role={currentSelectedRole} />
      </Modal>
      <div className={styles.roles}>
        <RolesSelector
          onClick={i => {
            setCurrentSelectedRole(ROLES[i].key)
          }}
        />
      </div>
      <div className={classnames(styles.wechatGame)}>
        <Title
          className={styles.wechatGameIntro}
          sub={
            <>
              突如其来的危机——时空浩劫，即将来袭，多维宇宙将万劫不复。吉考斯工业紧急启动了宇宙的救援行动，行动代号「弧光」。
              <br />
              为了阻止灾难的发生，我们邀请你一起加入，你将探访宇宙的不同位面，有贫瘠的生存废土、有隐藏在光鲜外表下的暗涌势力、还将见到人类的黄金时代、也有璀璨的虚拟空间。你的出身将代表了你的第一个冒险，请慎重选择。
            </>
          }
        >
          还能提前参加核聚变？
          <br />
          创建你的角色，加入弧光行动吧
        </Title>
        <div className={styles.wechatGameInfo}>
          <WechatGameQr alter />
        </div>
      </div>
    </Section>
  )
})

Roles.displayName = "ArcRoles"
export default Roles
